export const FINAL_TREATMENT_STEP_ACTION = Object.freeze({
  prepareCheckout: "prepare_checkout",
  revealProductSelection: "reveal_product_selection",
  useLegacyCompletion: "use_legacy_completion",
});

export const finalTreatmentStepAction = (
  questionType,
  isTreatmentJourney,
  locationContractVersion = null,
) => {
  if (!isTreatmentJourney) {
    return FINAL_TREATMENT_STEP_ACTION.useLegacyCompletion;
  }
  if (
    questionType === "shipping_address"
    && Number(locationContractVersion || 0) >= 4
  ) {
    return FINAL_TREATMENT_STEP_ACTION.revealProductSelection;
  }
  if ([
    "product_selection",
    "program_lab_checkout",
    "shipping_address",
  ].includes(questionType)) {
    return FINAL_TREATMENT_STEP_ACTION.prepareCheckout;
  }
  return FINAL_TREATMENT_STEP_ACTION.revealProductSelection;
};

export const shouldCompleteLegacyProductSelection = (
  questionType,
  isTreatmentJourney,
) => (
  !isTreatmentJourney && questionType === "product_selection"
);
